import React, { type ReactNode } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { colors } from '@skyslope/mache';

const useStyles = makeStyles(() => ({
  section: {
    width: '50%',
    display: 'flex',
    flexDirection: 'column',
    '&:first-child': {
      borderRight: `1px solid ${colors.grey[400]}`,
    },
  },
}));

interface IProps {
  children: ReactNode;
  id?: string;
}

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
const Section = (props: IProps) => {
  const classes = useStyles();

  return (
    <div className={classes.section} id={props.id}>
      {props.children}
    </div>
  );
};

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default Section;
